import styled from 'styled-components';
import { key } from 'styled-theme';

export default styled.div`
  display: flex;
  align-items: center;

  img {
    flex: 0 0 auto;
    margin: 0 20px;
  }

  ul {
    padding: 0;
    flex: 1 1 auto;
  }

  > div {
    flex: 1 1 auto;
  }

  li {
    list-style: none;
    display: block;
    padding-left: 15px;
    position: relative;

    + li {
      margin-top: 10px;
    }

    &:before {
      content: '';
      display: inline-block;
      width: 5px;
      height: 5px;
      border-radius: 100%;
      background: ${key('colors.red.default')};
      position: absolute;
      top: calc(50% - 2.5px);
      left: 0;
    }
  }
`;
